<div>
  <h6 class="mb-3">Message</h6>
  <mat-form-field class="mat-form-field__lg">
    <mat-label>Write text...</mat-label>
    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"></textarea>
  </mat-form-field>
</div>
